import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const failures = [{
  attempt: "Intentaste 'comer menos'",
  result: 'Más hambre, más antojos, más frustración.'
}, {
  attempt: 'Intentaste eliminar el azúcar',
  result: 'Los primeros 3 días bien... y al cuarto día un atracón.'
}, {
  attempt: 'Intentaste tomar agua',
  result: 'Sigues con antojo y ahora también estás enojada.'
}, {
  attempt: "Compraste snacks 'saludables'",
  result: '$8 por una bolsa de chips de lentejas que saben a cartón.'
}, {
  attempt: 'Fuerza de voluntad',
  result: 'Funciona... hasta que no funciona. Y se siente como un fracaso.'
}];
const solutions = [{
  title: 'Proteína',
  desc: 'para suprimir la grelina'
}, {
  title: 'Fibra',
  desc: 'para estabilizar la glucosa'
}, {
  title: 'Grasa sana',
  desc: 'para activar la saciedad'
}, {
  title: 'Sabor',
  desc: 'que de verdad satisfaga'
}];
export function PainAmplification() {
  return <section className="py-24 px-4 bg-brand-cream text-brand-darkText" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold font-heading mb-6 text-brand-dark" data-id="element-168">
            Por Qué Las Soluciones Actuales Fallan
          </h2>
          <p className="text-xl text-brand-dark/70" data-id="element-169">
            Probablemente ya intentaste varias cosas para controlar los antojos.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-170">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-red-100" data-id="element-171">
              <div className="mt-1 flex-shrink-0" data-id="element-172">
                <X className="text-brand-red w-6 h-6" data-id="element-173" />
              </div>
              <div data-id="element-174">
                <span className="font-semibold text-brand-dark block mb-1" data-id="element-175">
                  {item.attempt}
                </span>
                <span className="text-brand-dark/70" data-id="element-176">
                  Resultado: {item.result}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h3 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-178">
            ¿Sabes por qué todo eso falla?
          </h3>
          <p className="text-lg text-brand-dark/80 max-w-2xl mx-auto" data-id="element-179">
            Porque ninguna de esas estrategias ataca la causa real del antojo.
            Ninguna le da a tu cerebro lo que realmente está buscando:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-180">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4 + index * 0.1
        }} className="flex items-center gap-4 bg-brand-light/10 p-6 rounded-xl border border-brand-light/20" data-id="element-181">
              <CheckCircle2 className="text-brand-medium w-8 h-8 flex-shrink-0" data-id="element-182" />
              <div data-id="element-183">
                <span className="font-bold text-brand-dark text-lg block" data-id="element-184">
                  {item.title}
                </span>
                <span className="text-brand-dark/70" data-id="element-185">{item.desc}</span>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center text-xl font-medium text-brand-dark mt-12" data-id="element-186">
          Sin esas cuatro cosas juntas, el antojo regresa. Siempre.
        </motion.p>
      </div>
    </section>;
}